<template>
  <div class="code-input">
    <label
      v-if="label"
      :for="`${id}-0`"
      v-html="label"
    />
    <div class="inputs">
      <input
        v-for="(_, i) in noOfInputs"
        :id="`${id}-${i}`"
        :key="i"
        ref="input"
        v-model="value[i]"
        v-focus="autofocus && i === 0"
        maxlength="1"
        size="1"
        type="text"
        @input="(e) => onChange(e, i)"
        @keyup="(e) => onKeyUp(e, i)"
        @paste="onPaste"
      >
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CodeInput',
    props: {
      autofocus: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: null,
      },
      size: {
        type: [Number, String],
        default: 6,
      },
    },
    data() {
      return {
        id: `code-input-${Date.now()}`,
        value: [],
        pasteTimestamp: null,
      };
    },
    computed: {
      noOfInputs() {
        return parseInt(this.size);
      },
    },
    watch: {
      value(newValue) {
        const code = newValue.join('');
        this.$emit('input', code);
      },
    },
    methods: {
      focusInput(index) {
        this.$refs.input[index].focus();
      },
      focusPrevious(index) {
        if (index - 1 >= 0) {
          this.focusInput(index - 1);
        }
      },
      focusNext(index) {
        if (index + 1 < this.noOfInputs) {
          this.focusInput(index + 1);
        }
      },
      onChange(e, index) {
        const { value } = e.target;
        if (value.length > 0) {
          this.focusNext(index);
        }
      },
      onKeyUp(e, index) {
        const { key } = e;
        if (key === 'Backspace') {
          this.focusPrevious(index);
          return;
        }
        if (key === 'Enter') {
          this.$emit('enter');
        }
        if (key === 'Meta' || key === 'Control') {
          return; // Easy way to avoid keyboard paste events
        }
        const { value } = e.target;
        if (value.length > 0) {
          this.focusNext(index);
        }
      },
      onPaste(e) {
        const pasted = e.clipboardData.getData('text');
        for (let i = 0; i < this.noOfInputs; i += 1) {
          this.$set(this.value, i, pasted[i] || '');
        }
        this.focusInput(this.noOfInputs - 1);
      },
    },
  };
</script>

<style scoped lang="stylus">
  @require '~@/style/type'

  .code-input
    align-items: center
    display: flex
    flex-direction: column

  label
    @extend $type-small, $type-semibold
    color: #666

  .inputs
    margin-top: 6px

  input
    @extend $type-small
    appearance: none
    background-color: #fff
    border-radius: 3px
    border: 1px solid #D9D9D9
    box-sizing: border-box
    display: inline-block
    height 40px
    outline: none
    padding: 0 10px

    & + &
      margin-left: 6px
</style>
